import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { AddEdit as AddEditInterface } from "../../../../interfaces/transaction.interface";
import { Modules, RouteParamsTypes } from "../../../../enums";
import { VALIDATION_FIELD_MAPPING } from "../../../../utils/appConstant";

interface FormHeaderProps {
  formData: AddEditInterface;
  id: string;
  view: boolean;
  external?: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({ formData, id, view, external }) => {
  const { t } = useTranslation();

  const handleInvoiceClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <div className="d-flex justify-content-between">
      <h5 className={clsx("card-header", external && 'fs-4')}>{!id ? t("transactions.addEdit.pageTexts.title.addTitle") : (view ? t("transactions.addEdit.pageTexts.title.viewTitle") : t("transactions.addEdit.pageTexts.title.editTitle"))}</h5>

      <div className={clsx("d-flex align-items-center", !external && "p-5", external && "fs-6")}>
        {
          formData.invoiceNo && (
            <span className={clsx("text-primary me-3 fw-bold", !external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleInvoiceClick(formData.invoiceId)}>
              {t("transactions.addEdit.pageTexts.title.invoiceNo", { invoiceNumber: formData.invoiceNo })}
            </span>
          )
        }

        <span
          className={
            clsx(
              "badge rounded-pill px-3 py-2 fw-medium",
              formData.status === VALIDATION_FIELD_MAPPING.unBilled && "bg-secondary text-white",
              formData.status === VALIDATION_FIELD_MAPPING.invoice && "bg-warning text-white",
              formData.status === VALIDATION_FIELD_MAPPING.settled && "bg-info text-white"
            )
          }
        >
          {formData.statusLabel}
        </span>
      </div>
    </div>
  )
}

export default FormHeader;